import emailjs from "@emailjs/browser";

const SERVICE_ID =
  process.env.REACT_APP_REGISTRATION_EMAILJS_SERVICE_ID;

const TEMPLATE_ID =
  process.env.REACT_APP_REGISTRATION_EMAILJS_TEMPLATE_ID;

const PUBLIC_KEY =
  process.env.REACT_APP_REGISTRATION_EMAILJS_PUBLIC_KEY;

const ADMIN_EMAIL =
  process.env.REACT_APP_REGISTRATION_ADMIN_EMAIL;

export const sendRegistrationEmail = async (formData) => {
  const templateParams = {
    full_name: formData.full_name,
    email: formData.email,
    phone: formData.phone,
    whatsapp: formData.whatsapp,
    address: formData.address,
    qualification: formData.qualification,
    course: formData.course,
    mode: formData.mode,
    timeline: formData.timeline,
    questions: formData.questions,
    admin_email: ADMIN_EMAIL,
  };

  console.log("EmailJS params:", templateParams);

  const response = await emailjs.send(
    SERVICE_ID,
    TEMPLATE_ID,
    templateParams,
    PUBLIC_KEY
  );

  console.log("EmailJS response:", response);

  return response;
};